<div class="container py-3" style="max-width: 600px;">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2><i class="bi bi-car-front text-warning me-2"></i>{{ (isEdit ? 'admin.vehicle_type.title_edit' : 'admin.vehicle_type.title_new') | translate }}</h2>
    <button class="btn btn-outline-primary" (click)="goBack()">
      <i class="bi bi-arrow-left me-2"></i>{{ 'back' | translate }}
    </button>
  </div>

  <div class="card" *ngIf="vehicleType">
    <div class="card-body">
      <form ngNativeValidate (ngSubmit)="onSubmit()">
        <fieldset [disabled]="disabled" class="border-0 p-0 m-0">
        <table class="table">
          <tbody>
            <tr>
              <td class="fw-bold" style="width: 40%">{{ 'admin.vehicle_type.name' | translate }} *</td>
              <td>
                <s-input type="text" name="name" [(model)]="vehicleType.name" [required]="true"></s-input>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'admin.vehicle_type.avg_power' | translate }} *</td>
              <td>
                <s-input type="int" name="avg_charging_power_kw" [(model)]="vehicleType.avg_charging_power_kw"
                  [required]="true"></s-input>
                <small class="text-muted">{{ 'admin.vehicle_type.avg_power_hint' | translate }}</small>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'admin.vehicle_type.sort_order' | translate }}</td>
              <td>
                <s-input type="int" name="sort_order" [(model)]="vehicleType.sort_order"></s-input>
              </td>
            </tr>
            <tr>
              <td class="fw-bold">{{ 'active' | translate }}</td>
              <td>
                <s-input type="switch" name="is_active" [(model)]="vehicleType.is_active"></s-input>
              </td>
            </tr>
          </tbody>
        </table>
        </fieldset>

        <div class="d-flex justify-content-between mt-3">
          <div>
            <button *ngIf="isEdit" type="button" class="btn btn-outline-danger"
              [disabled]="disabled" (click)="deleteType()">
              <i class="bi bi-trash me-2"></i>{{ 'delete' | translate }}
            </button>
          </div>
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-secondary" (click)="goBack()">{{ 'cancel' | translate }}</button>
            <button type="submit" class="btn btn-accent" [disabled]="isSaving || disabled">
              <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isSaving" class="bi bi-save me-2"></i>{{ (isEdit ? 'save' : 'create') | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
